import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';

import { CountriesService, PayAndPlayService, SharedModule } from '@whitehatgaming/shared';
import { CreateAccountComponent } from './create-account/create-account.component';

import { AppRoutingModule } from './app-routing/app-routing.module';
import { brandConfig } from './brand-config';

import { environment } from '../environments/environment';
import { take } from 'rxjs';

@NgModule({
  declarations: [AppComponent, CreateAccountComponent],
  imports: [
    BrowserModule,
    AppRoutingModule, // first to declare wins
    SharedModule.forRoot(brandConfig, environment),
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private countriesService: CountriesService, private payAndPlayService: PayAndPlayService) {
    this.countriesService
      .getCountry()
      .pipe(take(1))
      .subscribe((country: any) => {
        this.payAndPlayService.setUserCountry(country.value);
      });
  }
}
